import { render } from "./ContactUsPage.vue?vue&type=template&id=6ae65209"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__